import React, { useEffect, useState } from 'react';
import './styles.css';

const Menubar = ({ isDarkMode, activePage = 'me', onMenuItemClick }) => {
    // Using state to force re-renders when active page changes
    const [activePageState, setActivePageState] = useState(activePage);
    // Track manually clicked items to prevent flicker
    const [manuallyClicked, setManuallyClicked] = useState(null);

    // Update local state whenever the activePage prop changes
    useEffect(() => {
        // Only update the active page if it wasn't manually clicked
        if (!manuallyClicked) {
            setActivePageState(activePage.toLowerCase());
        } else if (manuallyClicked.toLowerCase() === activePage.toLowerCase()) {
            // If the scroll completed and we reached the clicked section,
            // we can allow future scroll-based updates
            const timer = setTimeout(() => {
                setManuallyClicked(null);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [activePage, manuallyClicked]);

    // Throw an error if isDarkMode prop isn't provided
    if (isDarkMode === undefined) {
        throw new Error('isDarkMode prop is required for Menubar component');
    }

    const handleMenuItemClick = (itemId) => {
        // Set this item as manually clicked to prevent scroll-based overrides
        setManuallyClicked(itemId);
        // Also update active page state immediately
        setActivePageState(itemId.toLowerCase());

        if (onMenuItemClick) {
            // Pass the lowercase version to ensure consistency
            onMenuItemClick(itemId.toLowerCase());
        }
    };

    // Handler for namie image click to redirect to home
    const handleHomeClick = () => {
        handleMenuItemClick('me');
    };

    const menuItems = {
        "About Me": [
            {
                id: 'me',
                icon: '/images/siteElements/menubar/me.png',
                url: '/',
            },
            {
                id: 'education',
                icon: '/images/siteElements/menubar/edu.png',
                url: '/education',
            },
            {
                id: 'hobbies',
                icon: '/images/siteElements/menubar/hobbies.png',
                url: '/hobbies',
            }
        ],
        "Professional": [
            {
                id: 'experience',
                icon: '/images/siteElements/menubar/exp.png',
                url: '/experience',
            },
            {
                id: 'research',
                icon: '/images/siteElements/menubar/research.png',
                url: '/research',
            },
            {
                id: 'skills',
                icon: '/images/siteElements/menubar/skills.png',
                url: '/skills',
            },
            {
                id: 'activities',
                icon: '/images/siteElements/menubar/activities.png',
                url: '/activities',
                label: 'Activities'
            }
        ],
        "Miscellaneous": [
            {
                id: 'accolades',
                icon: '/images/siteElements/menubar/ach.png',
                url: '/accolades',
            },
            {
                id: 'projects',
                icon: '/images/siteElements/menubar/proj.png',
                url: '/projects',
            },
            {
                id: 'blog',
                icon: '/images/siteElements/menubar/blog.png',
                url: '/blog',
                label: 'Blog'
            }
        ]
    };

    return (
        <div className="menubar">
            <div className="menuLogo">
                <img
                    src={`/images/siteElements/menubar/menu_namie_${isDarkMode ? 'dark' : 'light'}.png`}
                    alt="Name Placard"
                    className="menubarNamePlacard"
                    onClick={handleHomeClick}
                    style={{ cursor: 'pointer' }}
                />
            </div>

            <div className="menuList">
                {Object.entries(menuItems).map(([category, items]) => (
                    <div key={category} className="menuCategory">
                        <div className="catTitle">{category}</div>
                        <div className="catItems">
                            {items.map((item) => {
                                // Determine active state prioritizing manually clicked items
                                const isActive =
                                    // First check if this was manually clicked
                                    (manuallyClicked && manuallyClicked.toLowerCase() === item.id.toLowerCase()) ||
                                    // Fall back to the normal activePageState behavior if not in manual mode
                                    (!manuallyClicked && activePageState.toLowerCase() === item.id.toLowerCase());

                                return (
                                    <div
                                        key={item.id}
                                        className={`menuItem ${isActive ? 'active' : ''}`}
                                    >
                                        <div
                                            className="menuLink"
                                            onClick={() => handleMenuItemClick(item.id)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <img src={item.icon} alt={item.id} className="menuIcon" />
                                            <span className="menuLabel">{item.label || item.id.charAt(0).toUpperCase() + item.id.slice(1)}</span>
                                            {isActive && <div className="active-indicator"></div>}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Menubar;